import React from 'react';
import { Outlet } from "react-router-dom";
import { observer } from "mobx-react-lite";

import { Navbar } from "../../Common/Components/Navbar";
import { filteringController } from './Controllers/FilteringController';

export const MainPage = observer(() => {
  return (
    <>
      <Navbar isSearchable={true} isBasketIconEnabled={true} isAccountIconEnabled={true} isInline={false} />
      {filteringController.searchValue ?
        <div className={`w-full h-[139px] smh:h-[143px] mdh:h-[160px] lgh:h-[176px]`}></div> :
        <div className={`w-full h-[104px] smh:h-[108px] mdh:h-[160px] lgh:h-[176px]`}></div>
      }
      <Outlet />
    </>
  )
});